import { render, staticRenderFns } from "./PlayerProcessedLanguage.vue?vue&type=template&id=166cbbff&scoped=true&"
import script from "./PlayerProcessedLanguage.vue?vue&type=script&lang=js&"
export * from "./PlayerProcessedLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166cbbff",
  null
  
)

export default component.exports